import React from "react";

import ModalConfirm from "./hoc/ModalConfirm";

import PhotoDefault from "../assets/img/photo-default.jpg";
import Loading from "./Loading";

export default class Perfil extends React.Component {
  state = {
    visible: true,
    modal: false,
    EditPass: false,
    ModalTitle: <p style={{ color: "black" }}>Atenção</p>,
    animacao: true,
  };

  componentWillMount() {
    const array = this.props.data;
    array.forEach((objeto) => {
      if (objeto.providerId === "password") {
        this.setState({
          EditPass: true,
          EditEmail: true,
        });
      }
    });
  }

  onDismiss = (event) => {
    this.setState({ visible: false });
  };

  onModal = (event) => {
    this.setState({ modal: !this.state.modal });
  };

  RenderPhoto = () => {
    if (this.props.allUser.foto !== null) {
      return (
        <img
          className="pull-left"
          src={this.props.allUser.foto}
          alt="Foto de perfil"
          width="100"
          height="100"
        />
      );
    } else {
      return <img src={PhotoDefault} alt="Foto padrão" width="100" height="100" />;
    }
  };

  render() {
    if (this.props.isLoading === true) return <Loading />;

    return (
      <div className="row dashboard mb-3 mt-3">
        <div className="col-sm-12 col-md-6">
          <div className="profile mb-3">
            <div className="mr-3">{this.RenderPhoto()}</div>
            <div className="pull-left">
              <span>
                Olá,{" "}
                <strong>
                  {this.props.allUser.nome}
                  <br />
                </strong>
              </span>
              <span>
                Email: {this.props.allUser.email}
                <br />
              </span>
              <div>
                <button
                  className="btn btn-primary btn-sm mr-2"
                  onClick={() => this.props.handleShowForm("perfil")}
                >
                  Editar Perfil
                </button>

                {this.state.EditPass ? (
                  <button
                    className="btn btn-primary btn-sm mr-2"
                    onClick={() => this.props.handleShowForm("senha")}
                  >
                    Redefinir Senha
                  </button>
                ) : null}

                {this.state.EditEmail ? (
                  <button
                    className="btn btn-primary btn-sm mr-2"
                    onClick={() => this.props.handleShowForm("email")}
                  >
                    Redefinir Email
                  </button>
                ) : null}

                <button className="btn btn-danger btn-sm" onClick={this.onModal}>
                  Sair
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="alert alert-success col-md-6" role="alert">
          <h4 className="align-text-center">Descobrindo seu IMEI</h4>
          <p>Tecle *#06# para exibir seu IMEI.</p>
        </div>

        <ModalConfirm
          title={this.state.ModalTitle}
          show={this.state.modal}
          toggle={this.onModal}
          ok={this.props.handleLogout}
          style={{ color: "black !important" }}
        >
          <p style={{ color: "black" }}>Tem certeza que deseja sair?</p>
        </ModalConfirm>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Perfil.js